import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';

interface AddSetMenuProps {
    onAdd: () => void;
    disabled?: boolean;
}

export const AddSetMenu = ({ onAdd, disabled = false }: AddSetMenuProps): JSX.Element => (
    <Button disabled={disabled} startIcon={<Add />} variant="contained" onClick={onAdd}>
        Add set
    </Button>
);
